module.exports = __webpack_public_path__ + "static/media/71.78dc8dde.jpg";